var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./historico.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1b5e9553\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./historico.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/apps/credenciada/consulta/_includes/historico.vue
// module id = 1287
// module chunks = 45